import removeNodes from "./removeNodes.js";

export const getPdfStringFromUrl = (url, index, hideImages) => {
  return new Promise((resolve, reject) => {
    //create a class name for targeting the iframe
    const className = `report-page-${index}`;

    //create an iframe element to load to page
    const iframe = document.createElement("iframe");
    const iframeSrc = hideImages
      ? `${url}?view=pdf&hideImage=true`
      : `${url}?view=pdf`;
    iframe.src = iframeSrc;
    //add general class to hide the added iframe
    iframe.classList.add("report-iframe");
    iframe.classList.add(className);
    iframe.addEventListener("load", () => {
      //setTime required to allow react components time to render
      setTimeout(() => {
        //get the page from inside the iframe
        const pageHTML = document
          .querySelector(`.${className}`)
          .contentDocument.querySelector("html");

        removeNodes(pageHTML, [
          ".carousel",
          "#mini-profiler",
          ".mp-results",
          "script",
          ".modal-container",
          ".bottom-navigation",
          "noscript",
        ]);

        //remove the iframe
        iframe.parentElement.removeChild(iframe);

        resolve(pageHTML.outerHTML.toString());
      }, 1000);
    });

    iframe.addEventListener("error", () => {
      iframe.parentElement.removeChild(iframe);
      reject(`Error loading '${className}'!`);
    });
    iframe.addEventListener("abort", () => {
      iframe.parentElement.removeChild(iframe);
      reject(`Aborted loading '${className}'!`);
    });

    //add the iframe to the end of the body
    document.querySelector("body").appendChild(iframe);
  });
};
